export default __webpack_public_path__ + "static/media/thumbnail.1e07a532.png";